import { BASE_API_URL } from "@/constants/api";
import toast from "react-hot-toast";

const networkHelper = () => {
  const isSuccess = (status: number) => {
    return status >= 200 && status <= 299;
  };

  const getBaseUrl = (): string => {
    return BASE_API_URL || "";
    // try {
    //   const userData = getUserData();
    //   const backendDomain = userData?.backend_domain;
    //   const currentUrl = window.location.href;
    //   const currentUrlDomain = new URL(currentUrl).hostname;

    //   if (import.meta.env.VITE_REACT_APP_USE_CUSTOM_URL === "true") {
    //     return BASE_API_URL || "";
    //   }

    //   if (backendDomain) {
    //     return `https://${backendDomain}/api/v1/`;
    //   } else if (currentUrlDomain) {
    //     return `https://${currentUrlDomain}/api/v1/`;
    //   } else {
    //     return BASE_API_URL || "";
    //   }
    // } catch (error) {
    //   console.error("Error in getBaseUrl", error);
    //   return BASE_API_URL || "";
    // }
  };

  const handleDownloadByUrl = async (download_url?: string): Promise<void> => {
    try {
      if (!download_url) {
        toast.error("No download URL found");
        return;
      }
      const response = await fetch(download_url);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = download_url.split("/").pop() || "download.pdf";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const handleDownloadByBlob = async (
    blob: Blob,
    fileName: string,
  ): Promise<void> => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    toast.success("Download started");
  };

  return {
    isSuccess,
    getBaseUrl,
    handleDownloadByUrl,
    handleDownloadByBlob,
  };
};

export default networkHelper;
